import clsx from "clsx"
import {
  ComponentPropsWithoutRef,
  PropsWithChildren,
  useEffect,
  useRef,
  FC
} from "react"
import styles from "./index.module.scss"

type FittyOptions = {
  minSize?: number
  maxSize?: number
  multiLine?: boolean
}
interface IFittyText extends FittyOptions, ComponentPropsWithoutRef<"div"> {
  pos?: "left" | "right" | "center"
}

export const FittyText: FC<PropsWithChildren<IFittyText>> = ({
  children,

  minSize = 1,
  maxSize = 14,
  multiLine = false,

  pos = "left",

  className,
  ...props
}) => {
  const refWrap = useRef<HTMLDivElement | null>(null)
  const refP = useRef<HTMLParagraphElement | null>(null)
  const instanceRef = useRef<any>(null)

  useEffect(() => {
    let resizeObsParent: ResizeObserver | null = null
    let resizeObsSelf: ResizeObserver | null = null
    let mutationObs: MutationObserver | null = null
    let cancelled = false

    ;(async () => {
      const { default: fitty } = await import("fitty")

      if (cancelled || !refP.current) return

      instanceRef.current = fitty(refP.current, {
        minSize,
        maxSize,
        multiLine
      })

      const parent = refP.current.parentElement
      if (parent && "ResizeObserver" in window) {
        resizeObsParent = new ResizeObserver(() => {
          instanceRef.current?.fit()
          instanceRef.current?.fit() // ★ подвійний fit
        })
        resizeObsParent.observe(parent)
      }

      if ("ResizeObserver" in window && refWrap.current) {
        resizeObsSelf = new ResizeObserver(() => {
          instanceRef.current?.fit()
          instanceRef.current?.fit() // ★
        })
        resizeObsSelf.observe(refWrap.current)
      }

      mutationObs = new MutationObserver(() => {
        instanceRef.current?.fit()
      })
      mutationObs.observe(refWrap.current!, {
        childList: true,
        characterData: true,
        subtree: true
      })

      // шрифти
      // @ts-ignore
      document.fonts?.ready?.then?.(() => {
        instanceRef.current?.fit?.()
        instanceRef.current?.fit?.() // ★
      })

      // ініціальний прорахунок через кадр
      requestAnimationFrame(() => {
        instanceRef.current?.fit?.()
        instanceRef.current?.fit?.() // ★
      })
    })()

    return () => {
      cancelled = true
      try {
        resizeObsParent?.disconnect()
      } catch {}
      try {
        resizeObsSelf?.disconnect()
      } catch {}
      try {
        mutationObs?.disconnect()
      } catch {}
      try {
        instanceRef.current?.unsubscribe()
      } catch {}
      instanceRef.current = null
    }
  }, [minSize, maxSize, multiLine])

  useEffect(() => {
    instanceRef.current?.fit?.()
    instanceRef.current?.fit?.() // ★
  }, [children])

  return (
    <div
      className={clsx(styles.FittyText, styles[pos], className)}
      ref={refWrap}
      {...props}
    >
      <p className={clsx(styles.FittyText_text)} ref={refP}>
        {children}
      </p>
    </div>
  )
}
